import { AddressDTO } from '../types';

export function formatAddress(dto?: AddressDTO | null): string {
  if (!dto) {
    return '-';
  }

  const parts: string[] = [];

  const streetPart = [dto.house, dto.street].filter(Boolean).join(' ');
  if (streetPart) {
    parts.push(streetPart);
  }

  if (dto.locality) {
    parts.push(dto.locality);
  }

  if (dto.province) {
    parts.push(dto.province);
  }

  return parts.join(', ');
}
